import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/products',
    name: 'ProductList',
    component: () => import('../views/product/ProductList.vue'),
    meta: {
      title: '作品列表'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/info/About.vue'),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/consult',
    name: 'Consult',
    component: () => import('../views/info/Consult.vue'),
    meta: {
      title: '文化资讯'
    }
  },
  {
    path: '/consultinfo/:id',
    name: 'ConsultInfo',
    component: () => import('../views/info/ConsultInfo.vue'),
    meta: {
      title: '资讯详情'
    }
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: () => import('../views/product/ProductDetail.vue'),
    meta: {
      title: '作品详情'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login.vue'),
    meta: {
      title: '会员登录'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/auth/Register.vue'),
    meta: {
      title: '会员注册'
    }
  },
  {
    path: '/code',
    name: 'WechatCallback',
    component: () => import('../views/auth/WechatCallback.vue'),
    meta: {
      title: '微信登录'
    }
  },
  {
    path: '/user/center',
    redirect: '/user-center'
  },
  {
    path: '/user-center',
    name: 'UserCenter',
    component: () => import('../views/user/UserCenter.vue'),
    meta: {
      title: '会员中心',
      requiresAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/profile-edit',
    name: 'ProfileEdit',
    component: () => import('../views/user/ProfileEdit.vue'),
    meta: {
      title: '编辑个人资料',
      requiresAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('../views/payment/Recharge.vue'),
    meta: {
      title: '会员充值',
      requiresAuth: true // 需要登录才能访问
    }
  },
  {
    path: '/pay',
    name: 'Pay',
    component: () => import('../views/payment/Pay.vue'),
    meta: {
      title: '支付处理'
    }
  }
]

const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE || 'history',
  base: process.env.VUE_APP_ROUTER_BASE || process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - 温故`
  }
  
  // 检查是否全局启用登录验证
  const requireLogin = process.env.VUE_APP_REQUIRE_LOGIN === 'true'
  
  // 检查是否需要登录（全局配置或页面级配置）
  const needsAuth = requireLogin || to.meta.requiresAuth
  
  if (needsAuth) {
    // 登录页面和注册页面不需要验证
    if (to.path === '/login' || to.path === '/register') {
      next()
      return
    }
  }
  
  next()
})

// 捕获路由错误，避免导航取消警告
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('navigation')) {
      return Promise.reject(err)
    }
  })
}

VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('navigation')) {
      return Promise.reject(err)
    }
  })
}

export default router
